<template>
  <el-dialog title="Preços" :visible.sync="dialog.detail" :close-on-click-modal="false" :fullscreen="true">
    <el-table :data="tableDetail" stripe style="width: 100%" size="mini" height="550">
      <el-table-column sortable fixed align="center" :label="$t('peso')" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.km">KG Adicional</span>
          <span v-else>
            {{ scope.row.weightstart }} à {{ scope.row.weightend }}
          </span>
        </template>
      </el-table-column>
      <el-table-column width="80px" prop="l1" label="L1">
        <template slot-scope="scope">{{ scope.row.l1 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="l2" label="L2">
        <template slot-scope="scope">{{ scope.row.l2 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="l3" label="L3">
        <template slot-scope="scope">{{ scope.row.l3 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="l4" label="L4">
        <template slot-scope="scope">{{ scope.row.l4 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="e1" label="E1">
        <template slot-scope="scope">{{ scope.row.e1 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="e2" label="E2">
        <template slot-scope="scope">{{ scope.row.e2 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="e3" label="E3">
        <template slot-scope="scope">{{ scope.row.e3 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="e4" label="E4">
        <template slot-scope="scope">{{ scope.row.e4 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="n1" label="N1">
        <template slot-scope="scope">{{ scope.row.n1 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="n2" label="N2">
        <template slot-scope="scope">{{ scope.row.n2 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="n3" label="N3">
        <template slot-scope="scope">{{ scope.row.n3 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="n4" label="N4">
        <template slot-scope="scope">{{ scope.row.n4 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="i1" label="I1">
        <template slot-scope="scope">{{ scope.row.i1 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="i2" label="I2">
        <template slot-scope="scope">{{ scope.row.i2 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="i3" label="I3">
        <template slot-scope="scope">{{ scope.row.i3 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="i4" label="I4">
        <template slot-scope="scope">{{ scope.row.i4 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="p1" label="P1">
        <template slot-scope="scope">{{ scope.row.p1 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="p2" label="P2">
        <template slot-scope="scope">{{ scope.row.p2 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="p3" label="P3">
        <template slot-scope="scope">{{ scope.row.p3 | currency }}</template>
      </el-table-column>
      <el-table-column width="80px" prop="p4" label="P4">
        <template slot-scope="scope">{{ scope.row.p4 | currency }}</template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button type="info" @click="editar()">Editar</el-button>
      <el-button @click="dialog.detail = false">OK</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { PriceTableService } from "@/services/customers/price.table.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "PriceTable",
  computed: {
    filterPackage() {
      const vm = this;
      const list = [];
      for (const row of vm.tableData) {
        if (!list.find((x) => x.value === row.packagetablename)) {
          list.push({
            text: row.packagetablename,
            value: row.packagetablename,
          });
        }
      }
      list.sort(function (a, b) {
        if (a.text > b.text) return 1;
        if (a.text < b.text) return -1;
        return 0;
      });
      return list;
    },
    filterService() {
      const vm = this;
      const list = [];
      for (const row of vm.tableData) {
        if (!list.find((x) => x.value === row.servicegroupname)) {
          list.push({
            text: row.servicegroupname,
            value: row.servicegroupname,
          });
        }
      }
      list.sort(function (a, b) {
        if (a.text > b.text) return 1;
        if (a.text < b.text) return -1;
        return 0;
      });
      return list;
    },
  },
  methods: {
    open(tableList) {
      const vm = this;
      vm.tableDetail = tableList;
      vm.dialog.detail = true;
    },
    editar() {
      const vm = this;
      vm.dialog.detail = false;
      this.$emit("edit")
    },
  },
  data() {
    return {
      tableDetail: [],
      dialog: { detail: false },
    };
  },
};
</script>
<style>
.right {
  float: right;
}

.small {
  font-size: 11px;
}
</style>